import { Injectable, Inject, Optional } from '@angular/core';
import { SeoService } from '@common/services/seo.service';
import { Meta, Title } from '@angular/platform-browser';
import { ContentService } from '@common/services/content.service';
import { CommunityService } from '@common/services/community.service';
import { CANONICAL_COMMUNITY } from '@common/app/app.config';
import { LinkService } from '@common/services/link.service';
import { LanguageService } from '@common/services/language.service';

@Injectable({
    providedIn: 'root'
})
export class EnusSeoService extends SeoService {

    constructor(meta: Meta,
        content: ContentService,
        communityService: CommunityService,
        title: Title,
        @Inject(CANONICAL_COMMUNITY) canonicalCommunity: string,
        linkService: LinkService,
        @Optional() languageService: LanguageService) {
        super(meta, content, communityService, title, canonicalCommunity, linkService, languageService);
    }

    generateCanonicalHref(urlArray: string[], selectedCanonicalCommunity: string): string {
        let subPage: string;
        const language = this.languageService.currentLanguageCode;
        const pageNumber = this.communityService.communityCode ? 3 : 2;
        const page = urlArray[pageNumber];
        const canonicalCommunity = selectedCanonicalCommunity;
        switch (page) {
            case 'info':
                if (urlArray[pageNumber + 1] === undefined) { return; }
                subPage = urlArray[pageNumber + 1];
                break;
            case 'do':
                return;
            case 'error':
                return;
        }

        let canonicalHref = [document.getElementsByTagName('base')[0].href, canonicalCommunity, language, page, subPage]
            .filter(part => !!part)
            .map(part => part.replace(new RegExp('^\/+|\/+$', 'g'), '')) // remove starting and trailing '/'
            .map(part => part.toLocaleLowerCase())
            .reduce((prev, cur) => `${prev}/${cur}`);

        return canonicalHref += page === '' ? '/' : '';
    }

    selectCanonicalCommunity(customCanonicalCommunity?: string) {
        return this.canonicalCommunity;
    }
}
